import push from '../../utils/routing';

export default (spaceId, sectionId, queryParams) => () => {
  const basePath = `/dashboard/${spaceId}/journey/engagement`;

  push({
    pathname: basePath,
    ...(queryParams ? { query: queryParams } : {}),
  });
};
